"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGridContainer = exports.SlideContentContainer = exports.PipContainer = exports.Pip = exports.OverflowContainer = exports.ChevronOverlayButton = exports.CarouselSnapSection = exports.CarouselLayout = exports.CarouselItemGrid = exports.CarouselContainer = exports.CarouselButton = exports.ButtonContainer = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _tappablearea = require("../../fuse-tappable-area/src/tappablearea");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CarouselContainer = exports.CarouselContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-carousel'
}).withConfig({
  displayName: "styled-carousel__CarouselContainer",
  componentId: "sc-19gnz37-0"
})(["display:flex;flex-direction:column;@supports (scroll-snap-type){.slider > a{display:none;}}"]);
var OverflowContainer = exports.OverflowContainer = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['touchPeek', 'chevronOverlay'].includes(prop);
  }
}).attrs({
  className: 'fuse-carousel__overflow-container'
}).withConfig({
  displayName: "styled-carousel__OverflowContainer",
  componentId: "sc-19gnz37-1"
})(["display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}", ";"], function (_ref) {
  var touchPeek = _ref.touchPeek,
    chevronOverlay = _ref.chevronOverlay;
  return "\n\t\t".concat(touchPeek ? "\n\t\t\tmargin-right: calc(-1 * ".concat(_grid.gridConfig.xxs.margin, ");\n\n\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\t// Chevron overlay does not have peek for tablet and desktop\n\t\t\t\tmargin-right: ").concat(chevronOverlay ? "0" : "calc(-1 * ".concat(_grid.gridConfig.m.margin, ")"), ";\n\t\t\t}\n\n\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\t\tmargin-right: 0;\n\t\t\t}") : "", ";\n\t");
});
var StyledGridContainer = exports.StyledGridContainer = (0, _styledComponents["default"])(_grid.GridContainer).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'gridContainerPadding';
  }
}).attrs({
  className: 'fuse-carousel__styled-grid-container'
}).withConfig({
  displayName: "styled-carousel__StyledGridContainer",
  componentId: "sc-19gnz37-2"
})(["@media screen and (min-width:", "){padding:", ";}"], _grid.gridConfig.l.minWidth, function (props) {
  return props.gridContainerPadding ? ' ' : '0';
});
var Pip = exports.Pip = _styledComponents["default"].button.attrs({
  className: 'fuse-carousel__pip'
}).withConfig({
  displayName: "styled-carousel__Pip",
  componentId: "sc-19gnz37-3"
})(["display:flex;background-color:var(--color-global-grey800);width:44px;height:var(--spacing-global-space1);margin:21px 4px;position:relative;border:0;&.current{background-color:var(--color-brand-mid);}&:focus{outline:none;}&:focus-visible:after,&:active{", "}&:focus:not(:focus-visible){outline:none;}", " &:after{cursor:pointer;}"], _fuseUtils.FocusCss, _tappablearea.TappableArea);
var ButtonContainer = exports.ButtonContainer = (0, _styledComponents["default"])(_grid.GridItem).attrs({
  className: 'fuse-carousel__button-container'
}).withConfig({
  displayName: "styled-carousel__ButtonContainer",
  componentId: "sc-19gnz37-4"
})(["place-items:center;"]);
var RenderIcon = function RenderIcon(Icon) {
  return (0, _server.renderToStaticMarkup)(Icon);
};
var CarouselButton = exports.CarouselButton = _styledComponents["default"].button.attrs({
  className: 'fuse-carousel__button'
}).withConfig({
  displayName: "styled-carousel__CarouselButton",
  componentId: "sc-19gnz37-5"
})(["&.fuse-carousel__button-previous{-webkit-box-pack:start;-ms-flex-pack:start;-webkit-justify-content:start;justify-content:start;}&.fuse-carousel__button-next{-webkit-box-pack:end;-ms-flex-pack:end;-webkit-justify-content:end;justify-content:end;}width:44px;height:44px;background:var(--color-global-white);display:inline-flex;border:0;cursor:pointer;justify-content:center;align-items:center;padding-inline:0;&:after{content:'';width:32px;height:32px;mask:url('data:image/svg+xml,", "') center/cover no-repeat;-webkit-mask:url('data:image/svg+xml,", "') center/cover no-repeat;background:var(--color-global-black);transition-duration:300ms;}&:hover:not(:disabled):after{background:var(--color-brand-mid);}&:focus-visible:after{background:var(--color-brand-mid);}&:focus-visible,&:active:not(:disabled){outline:var(--spacing-global-space1) solid var(--color-functional-focus);}&:active:not(:disabled){background:var(--color-brand-mid);}&:active:not(:disabled):after{background:var(--color-global-white);}&:focus:not(:focus-visible){outline:none;}&:disabled{opacity:0.2;cursor:default;}"], function (props) {
  return encodeURIComponent(RenderIcon(props.icon));
}, function (props) {
  return encodeURIComponent(RenderIcon(props.icon));
});
var ChevronOverlayButton = exports.ChevronOverlayButton = (0, _styledComponents["default"])(CarouselButton).attrs({
  className: "fuse-carousel__chevron-overlay-button",
  'data-testid': "fuse-carousel__chevron-overlay-button"
}).withConfig({
  displayName: "styled-carousel__ChevronOverlayButton",
  componentId: "sc-19gnz37-6"
})(["display:none;@media screen and (min-width:", "){", "}"], _grid.gridConfig.m.minWidth, function (_ref2) {
  var position = _ref2.position;
  return "\n\t\tdisplay: inline-flex;\n\t\tposition: absolute;\n\t\t".concat(position, ": 0;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tz-index: 2;\n\t");
});
var SlideContentContainer = exports.SlideContentContainer = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['touchPeek', 'lSlides', 'mSlides', 'xxsSlides', 'chevronOverlay', 'columnGapSize'].includes(prop);
  }
}).attrs({
  className: 'fuse-carousel__slide-content-container'
}).withConfig({
  displayName: "styled-carousel__SlideContentContainer",
  componentId: "sc-19gnz37-7"
})(["", ""], function (_ref3) {
  var touchPeek = _ref3.touchPeek,
    xxsSlides = _ref3.xxsSlides,
    mSlides = _ref3.mSlides,
    lSlides = _ref3.lSlides,
    chevronOverlay = _ref3.chevronOverlay,
    columnGapSize = _ref3.columnGapSize;
  var gapSizes = _objectSpread({}, _config.defaultColumnGaps);
  if (columnGapSize) {
    Object.keys(columnGapSize).forEach(function (breakpoint) {
      var gapSizeSpacingNumber = columnGapSize[breakpoint];
      if (gapSizeSpacingNumber && (0, _config.isColumnGapSizeValid)(gapSizeSpacingNumber, breakpoint)) {
        gapSizes[breakpoint] = "var(--spacing-global-space".concat(gapSizeSpacingNumber, ")");
      }
    });
  }
  return "\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tposition: relative;\n\n\t\t".concat(touchPeek ? "\n\t\t\t\t\tflex: 0 0 calc(".concat(xxsSlides, " * 95%);\n\t\t\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\t\t\tflex: ").concat(chevronOverlay ? "0 0 calc(".concat(mSlides, "00% + (").concat(mSlides - 1, " * ").concat(gapSizes.m, "));") : "0 0 calc(".concat(mSlides, " * 95%);"), "\n\t\t\t\t\t}\n\t\t\t\t") : "\n\t\t\tflex: 0 0 calc(".concat(xxsSlides, "00% + (").concat(xxsSlides - 1, " * ").concat(gapSizes.xxs, "));\n\n\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\tflex: 0 0 calc(").concat(mSlides, "00% + (").concat(mSlides - 1, " * ").concat(gapSizes.m, "));\n\t\t\t}\n\t\t"), "\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\tflex: 0 0 calc(").concat(lSlides, "00% + (").concat(lSlides - 1, " * ").concat(gapSizes.l, "));\n\t\t}\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.xl.minWidth, ") {\n\t\t\tflex: 0 0 calc(").concat(lSlides, "00% + (").concat(lSlides - 1, " * ").concat(gapSizes.xl, "));\n\t\t}\n\t");
});
var CarouselSnapSection = exports.CarouselSnapSection = (0, _styledComponents["default"])(_grid.GridItem).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'chevronOverlay';
  }
}).attrs({
  as: 'li',
  className: 'fuse-carousel__carousel-snap-section'
}).withConfig({
  displayName: "styled-carousel__CarouselSnapSection",
  componentId: "sc-19gnz37-8"
})(["scroll-snap-align:start;height:1px;:first-of-type{grid-column-start:1;}grid-column:auto / span 12;@media screen and (min-width:", "){", "}"], _grid.gridConfig.l.minWidth, function (_ref4) {
  var chevronOverlay = _ref4.chevronOverlay;
  return chevronOverlay ? "grid-column: auto / span 12;" : "grid-column: auto / span 10;";
});
var CarouselItemGrid = exports.CarouselItemGrid = (0, _styledComponents["default"])(_grid.GridRow).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['columnGapSize', 'lSlides', 'mSlides', 'xxsSlides', 'chevronOverlay'].includes(prop);
  }
}).attrs({
  forwardedAs: 'ul',
  className: 'fuse-carousel__item-grid'
}).withConfig({
  displayName: "styled-carousel__CarouselItemGrid",
  componentId: "sc-19gnz37-9"
})(["&&{max-width:100%;grid-row-gap:0;", " ", "}a{outline-offset:-2px;}.fuse-product-card:focus-visible{padding:4px;}"], function (_ref5) {
  var xxsSlides = _ref5.xxsSlides,
    mSlides = _ref5.mSlides,
    lSlides = _ref5.lSlides,
    chevronOverlay = _ref5.chevronOverlay;
  return "\n\t\t\tgrid-template-columns: repeat(".concat(12 * xxsSlides, ", 1fr);\n\n\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\tgrid-template-columns: repeat(").concat(12 * mSlides, ", 1fr);\n\n\t\t\t\t.fuse-carousel__carousel-snap-section:nth-of-type(").concat(mSlides, ") ~ .fuse-carousel__carousel-snap-section {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\t\tgrid-template-columns: ").concat(chevronOverlay ? "repeat(".concat(12 * lSlides, ", 1fr)") : "repeat(".concat(10 * lSlides, ", 1fr)"), " ;\n\n\t\t\t\t.fuse-carousel__carousel-snap-section:nth-of-type(").concat(lSlides, ") ~ .fuse-carousel__carousel-snap-section {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.xl.minWidth, ") {\n\t\t\t\tgrid-template-columns: ").concat(chevronOverlay ? "repeat(".concat(12 * lSlides, ", 1fr)") : "repeat(".concat(10 * lSlides, ", 1fr)"), " ;\n\t\t\t}\n\t\t");
}, function (_ref6) {
  var columnGapSize = _ref6.columnGapSize;
  return columnGapSize ? Object.keys(columnGapSize).map(function (breakpoint) {
    var gapSizeSpacingNumber = columnGapSize[breakpoint];
    return _grid.gridConfig[breakpoint] && gapSizeSpacingNumber && (0, _config.isColumnGapSizeValid)(gapSizeSpacingNumber, breakpoint) && "\n\t\t\t\t\t\t\t\t\t@media screen and (min-width: ".concat(_grid.gridConfig[breakpoint].minWidth, ") {\n\t\t\t\t\t\t\t\t\t\tcolumn-gap: var(--spacing-global-space").concat(gapSizeSpacingNumber, ");\n\t\t\t\t\t\t\t\t\t}");
  }).filter(Boolean).join('\n\r') : '';
});
var PipContainer = exports.PipContainer = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['lSlides', 'mSlides'].includes(prop);
  }
}).attrs({
  className: 'fuse-carousel__pip-container'
}).withConfig({
  displayName: "styled-carousel__PipContainer",
  componentId: "sc-19gnz37-10"
})(["display:flex;justify-content:center;", ";"], function (props) {
  return "\n\t\t@media screen and (min-width: ".concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\tbutton:nth-child(").concat(props.mSlides, ") ~ * {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\tbutton:nth-child(").concat(props.lSlides, ") ~ * {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t");
});
var gridTemplateAreaChange = function gridTemplateAreaChange(prop) {
  return prop.title ? "'. title title'\n\t\t 'prev slides next'\n\t\t 'pips pips pips'" : "'prev slides next' 'pips pips pips'";
};
var CarouselLayout = exports.CarouselLayout = (0, _styledComponents["default"])(_grid.GridRow).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['chevronOverlay', 'gridAreaOverride'].includes(prop);
  }
}).attrs({
  className: 'fuse-carousel__carousel-layout'
}).withConfig({
  displayName: "styled-carousel__CarouselLayout",
  componentId: "sc-19gnz37-11"
})(["position:relative;&&{grid-template-columns:1fr 10fr 1fr;grid-template-areas:", ";[class^='SrOnly']{display:none;}@media screen and (max-width:", "){.SrOnlyXxs{display:inline;}}@media screen and (min-width:", ") and (max-width:", "){.SrOnlyM{display:inline;}", "}@media screen and (min-width:", "){grid-template-columns:", ";", " .SrOnlyL{display:inline;}}}"], function (_ref7) {
  var title = _ref7.title;
  return title ? "'title title title'\n\t\t'slides slides slides'\n\t\t'pips pips pips'" : "'slides slides slides'\n\t\t'pips pips pips'";
}, _grid.gridConfig.m.minWidth, _grid.gridConfig.m.minWidth, _grid.gridConfig.m.maxWidth, function (_ref8) {
  var chevronOverlay = _ref8.chevronOverlay,
    title = _ref8.title;
  return chevronOverlay ? "\n\t\t\t\t\t\tgrid-template-columns: 12fr;\n\t\t\t\t\t\tgrid-template-areas: ".concat(title ? "'title'\n\t\t\t\t\t\t\t'slides'\n\t\t\t\t\t\t\t'pips'" : "'slides'\n\t\t\t\t\t\t\t'pips'", ";\n\t\t\t\t\t") : "\n\t\t\t\t\t";
}, _grid.gridConfig.l.minWidth, function (props) {
  return props.gridAreaOverride ? '6rem 1fr 6rem;' : '1fr 10fr 1fr';
}, function (_ref9) {
  var chevronOverlay = _ref9.chevronOverlay,
    title = _ref9.title,
    gridAreaOverride = _ref9.gridAreaOverride;
  return chevronOverlay ? "\n\t\t\t\t\t\tgrid-template-columns: 12fr;\n\t\t\t\t\t\tgrid-template-areas:\n\t\t\t\t\t\t\t".concat(title ? "'title'\n\t\t\t\t\t\t\t'slides'\n\t\t\t\t\t\t\t'pips'" : "'slides'\n\t\t\t\t\t\t\t'pips'", ";\n\t\t\t\t\t") : "\n\t\t\t\t\t\tgrid-template-areas:\n\t\t\t\t\t\t\t".concat(title && gridAreaOverride ? "'title title title'\n\t\t\t\t\t\t\t'prev slides next'\n\t\t\t\t\t\t\t'pips pips pips'" : gridTemplateAreaChange({
    title: title
  }), ";\n\t\t\t\t\t");
});